<template>
  <b-modal :id="id" hide-footer @shown="handleScrollToItem" @hidden="hideModal" v-model="isModalShown" centered body-class="pt-0 px-0">
    <template #modal-header="{ close }">
      <span class="titleHeader pt-2">{{ titleHeader }}</span>
      <div class="button-modal-header d-flex flex-row">
        <b-button
          v-if="indexInternal === -1"
          size="sm"
          class="buttonReset"
          variant="link"
          @click="resetFormModal"
        >
          クリア
        </b-button>
        <b-button
          v-if="(indexInternal !== -1) && (!hideDeleteToAction) && isMasterTableUnlocked"
          size="sm"
          @click="handleDeleteRowData"
          class="delete_btn d-flex flex-row align-items-center"
          variant="link"
        >
          <span class="material-icons material-icons-outlined delete_icon_detail">
            delete
          </span>
          削除
        </b-button>
        <b-button
          size="sm"
          @click="onCreate"
          class="buttonSave d-flex flex-row justify-content-center text-white align-items-center"
          v-if="!hideSaveToAction && isMasterTableUnlocked"
        >
          保存
        </b-button>
        <b-button
          size="sm"
          class="buttonClose d-flex flex-row align-items-center"
          variant="link"
          @click="close()"
        >
          <i class="material-icons material-icons-outlined">close</i>
        </b-button>
      </div>
    </template>
    <template>
      <AlertMessageComponent class="txtErrorMessage"/>
      <div id="scrollspy-filed" :class="[this.errorMessageArray.length > 0 ? 'pt-1' : 'pt-0']">
        <hr :class="[this.errorMessageArray.length > 0 ? 'my-0 ml-2 mr-1' : 'd-none']" />
        <div v-for="(tLabel, key) in tableLabels" :key="key" class="pl-2 pr-1">
          <b-row :data-itemno="tLabel.isItemNo" class="d-flex align-items-center ml-2 mr-1">
            <b-col
              sm="4"
              class="d-flex pl-0 my-3 pr-2"
              v-if="option[tLabel.isItemNo] || indexInternal >= 0"
            >
              <label for="input-default" class="lblItemName">
                {{ tLabel.itemName }}
                <span
                  class="required"
                  v-if="option[tLabel.isItemNo] && option[tLabel.isItemNo].required && isRequiredKeyName(createData)"
                  >
                  必須
                  </span>
              </label>
            </b-col>
            <b-col sm="8" class="px-0 my-3" v-if="option[tLabel.isItemNo] || indexInternal >= 0">
              <!-- INPUT TYPE TEXT -->
              <span v-if="tLabel.dataType === 0 && !checkShowTextArea(tLabel.isItemNo, indexInternal)" class="w-100">
                <input-text-component
                  :id="tLabel.isItemNo"
                  :disabled="isTextDisabled(tLabel.isItemNo)"
                  :autofocus="tLabel.isItemNo === itemNo ? true : false"
                  :enableTrimValue="true"
                  v-model="createData[tLabel.isItemNo]"
                  v-if="isMasterTableUnlocked && option[tLabel.isItemNo]"
                  @keydown.enter="onCreate"
                  :maxlength="getRulesMinMax(option[tLabel.isItemNo]['rules'])"
                  :state="!Object.keys(message[tLabel.isItemNo] || {}).length ? false : true"
                />
                <label v-else class="lblInputField" :class="[{'multiline-label': tLabel.isItemNo === descriptionKey || tLabel.isItemNo === defaultValue}]">
                  <span>{{ createData[tLabel.isItemNo] | unescapeNewLineChar }}</span>
                </label>
              </span>
              <!-- INPUT TYPE TEXT AREA -->
              <span v-if="checkShowTextArea(tLabel.isItemNo, indexInternal)" class="w-100">
                <input-text-area-component
                  :id="tLabel.isItemNo"
                  :disabled="isTextDisabled(tLabel.isItemNo)"
                  :autofocus="tLabel.isItemNo === itemNo ? true : false"
                  v-model="createData[tLabel.isItemNo]"
                  v-if="isMasterTableUnlocked && option[tLabel.isItemNo]"
                  :maxlength="getRulesMinMax(option[tLabel.isItemNo]['rules'])"
                  :state="!Object.keys(message[tLabel.isItemNo] || {}).length ? false : true"
                />
                <label v-else class="lblInputField" :class="{'multiline-label': tLabel.isItemNo === descriptionKey}">
                  <span>{{ createData[tLabel.isItemNo] | unescapeNewLineChar }}</span>
                </label>
              </span>
              <!-- INPUT TYPE LIST -->
              <span v-if="tLabel.dataType === 2" class="w-100">
                <form-select-component
                  :isDisabled="isDisabled"
                  v-model="selected[tLabel.isItemNo]"
                  :options="tLabel.mstGenCode.filter(genCode => !genCode.noDisplayFlag).map(genCode => genCode.code)"
                  :customLabel="opt => getGenCodeName(tLabel.mstGenCode, opt)"
                  v-if="isMasterTableUnlocked && option[tLabel.isItemNo]"
                  :autofocus="tLabel.isItemNo === itemNo ? true : false"
                  @onClose="handleOnClose(tLabel.isItemNo)"
                />
                <span v-else>
                  <label class="lblInputField">
                    {{ tLabel.mstGenCode | displayValueByGenCode(selected[tLabel.isItemNo])}}
                  </label>
                </span>
              </span>
              <!-- INPUT TYPE NUMBER -->
              <span v-if="tLabel.dataType === 1" class="w-100">
                <input-number-component
                  v-if="isMasterTableUnlocked && option[tLabel.isItemNo]"
                  :disabled="isNumberDisabled(tLabel.isItemNo)"
                  @keydown.enter="onCreate"
                  :maxValue="getRulesMinMax(option[tLabel.isItemNo]['rules'])"
                  :minValue="getRulesMinMax(option[tLabel.isItemNo]['rules'], false)"
                  :id="tLabel.isItemNo"
                  v-model.number="createData[tLabel.isItemNo]"
                  :autofocus="tLabel.isItemNo === itemNo ? true : false"
                  :state="Object.keys(message[tLabel.isItemNo] || {}).length ? true : false"
                />
                <label v-else class="lblInputField">
                  {{ createData[tLabel.isItemNo] }}
                </label>
              </span>
              <!-- INPUT TYPE DATE -->
              <span v-if="isMasterTableUnlocked && tLabel.dataType === 3" class="w-100">
                <label v-if="!option[tLabel.isItemNo]" class="lblInputField">
                  {{ createData[tLabel.isItemNo] | formatedDate }}
                </label>
              </span>
              <ul
                :style="{display: message[tLabel.isItemNo] && Object.entries(message[tLabel.isItemNo]).length >= 1 ? 'block' : 'none'}"
                class="mb-1 p-0 text-danger"
                style="list-style: none"
              >
                <li
                  v-for="(errorMessage, key2) in message[tLabel.isItemNo] || {}"
                  :key="key2"
                >
                  <small>{{ errorMessage }}</small>
                </li>
              </ul>
            </b-col>
          </b-row>
          <hr v-show="option[tLabel.isItemNo] || indexInternal !== -1" class="my-0" />
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import VueScrollTo from 'vue-scrollto'
import AlertMessageComponent from './AlertMessageComponent.vue'
import InputNumberComponent from './InputNumberComponent.vue'
import FormSelectComponent from './FormSelectComponent.vue'
import FlashMessage from '../../common/flash-message.component'
import InputTextComponent from './InputTextComponent.vue'
import InputTextAreaComponent from './InputTextAreaComponent.vue'
import RulesValidate from '../../common/rules-validate.js'
import { FieldDataType } from '../../enums/field-data-type.enums.js'
import { DevSettingDataType } from '../../enums/dev-setting-data-type.enums.js'
import AppConstants from '../../constants/app.constants'
import StringUtils from '../../_helpers/string.util'
const EMERGENCY_FLAG = 'rcsEmergencyStopFlag'
const NOT_REQUIRED_SETTING_KEYS = []
const moment = require('moment')
const UPDATE_TIME_KEY = 'updateTime'
// テキスト領域を表示するためにチェックする必要があるフィールドのリスト
const FIELD_LIST = ['settingValue']
export default {
  components: {
    DatePicker,
    AlertMessageComponent,
    InputNumberComponent,
    FormSelectComponent,
    InputTextComponent,
    InputTextAreaComponent,
    FieldDataType,
    DevSettingDataType
  },
  props: {
    tableLabels: {
      type: Array
    },
    tableNo: '',
    noWorkTaskType: Array,
    option: {
      type: Object
    },
    id: String,
    tableData: Array,
    hideDeleteToAction: Boolean,
    hideSaveToAction: Boolean,
    isSuccess: Boolean,
    primaryKey: String,
    tableApi: String,
    isLoading: Boolean,
    isMasterTableUnlocked: Boolean
  },
  data() {
    return {
      selected: {},
      originalSelected: {},
      createData: {},
      message: {},
      indexInternal: -1,
      titleHeader: '',
      itemNo: null,
      isSubmit: false,
      isDisabled: false,
      preUpdateTimeFieldValue: null,
      newItemData: {},
      beNotifiedSocket: false,
      serialId: 0,
      isEditModalMode: false,
      isModalShown: false,
      descriptionKey: AppConstants.DESCRIPTION_KEY,
      defaultValue: AppConstants.DEFAULT_VALUE_KEY
    }
  },
  filters: {
    formatedDate(date) {
      return date && moment(date).format('L LT')
    },
    // The displayValueByGenCode method will run when data type = 2
    displayValueByGenCode(mstGenCode, selectedValue) {
      const indexOf = mstGenCode.findIndex(el => el.code === selectedValue)
      if (indexOf !== -1) {
        return mstGenCode[indexOf].name
      }
      return selectedValue
    },
    /**
     * エスケープされた改行文字を実際の改行に変換します。
     * @param {string} text 変換される文字列
     * @returns 「\n」を含む文字列を返します
     */
    unescapeNewLineChar(text) {
      return StringUtils.unescapeNewLineChar(text)
    }
  },
  watch: {
    isSuccess(newVl, oldVl) {
      this.isSuccess = newVl
    },
    isLoading(newVl, oldVl) {
      this.isLoading = newVl
    },
    isModalShown(val) {
      this.isModalShown = val
    },
    tableLabels: {
      handler(newVl, oldVl) {
        if (oldVl.length === 0 || !this.isModalShown) {
          return
        }
        if (this.tableNo === 'trTask') {
          for (let key in newVl) {
            let isItemNo = this.tableLabels[key].isItemNo
            let dataType = this.tableLabels[key].dataType
            if (dataType === FieldDataType.LIST) {
              if (isItemNo === 'status') {
                // タスクの場合、タスクステータスオプション表示/非表示設定
                this.taskStatusOptionsDisplaySetting(this.indexInternal, this.tableLabels[key].mstGenCode)
              }
            }
          }
        }
      },
      deep: true
    }
  },
  beforeUpdate() {
    for (let key in this.tableLabels) {
      let keyName = this.tableLabels[key]['isItemNo']
      let notNullFlag = this.tableLabels[key]['notNullFlag']
      // テーブル管理マスタの必須項目をeditableに追加
      if (this.option[keyName]) {
        if (notNullFlag === 1) {
          this.option[keyName]['required'] = true
          if (this.option[keyName]['rules']) {
            if (this.option[keyName]['rules'].indexOf('notZero') === -1) {
              this.option[keyName]['rules'].push('required')
            } else {
              this.option[keyName]['rules'].push('required_notZero')
            }
          } else {
            this.option[keyName].push({ rules: ['required'] })
          }
        } else {
          this.option[keyName]['required'] = false
        }
      }
    }
  },
  computed: {
    ...mapGetters('flashMessage', ['errorMessageArray'])
  },
  methods: {
    ...mapGetters('setting', ['getSetting']),
    $_initValidateData() {
      for (let key in this.message) {
        for (let childKey in this.message[key]) {
          if (this.message[key][childKey]) {
            delete this.message[key][childKey]
          }
        }
        this.$set(this.message, key, {})
      }
    },
    /**
     * ドロップダウンを閉じた後、値が変更されたかどうかを確認します
     * 値が変更された場合は onInputChange を実装します方法。
     * 選択ドロップダウンが非表示の場合、モーダルにフォーカスします
     * @param {string} itemNo mst テーブル フィールド
     */
    handleOnClose(itemNo) {
      if (this.originalSelected[itemNo] !== this.selected[itemNo]) {
        this.onInputChange(itemNo)
      }
    },
    onInputChange(itemNo) {
      if (itemNo === EMERGENCY_FLAG && this.tableNo === 'mstRcs' && this.indexInternal !== -1) {
        this.modalConfirm(itemNo)
      }
    },
    modalConfirm(itemNo) {
      const setting = this.getSetting()
      this.$bvModal.msgBoxConfirm(`この項目は${setting.data.mstSetting.isName || ''}内部で管理している値です。強制的に変更した場合、正常な動作に支障が出る可能性があります。それでも変更しますか？`, {
        title: '変更してよろしいでしょうか？',
        size: 'sm',
        okVariant: 'link text-dark text-decoration-none',
        cancelVariant: 'link text-dark text-decoration-none',
        okTitle: 'OK',
        cancelTitle: 'キャンセル',
        id: 'modal-confirm',
        footerClass: 'justify-content-around p-1',
        hideHeaderClose: false,
        class: 'modalConfirm',
        centered: true
      })
        .then(isConfirm => {
          if (!isConfirm) {
            this.selected[itemNo] = this.originalSelected[itemNo]
          } else {
            this.selected[itemNo] = this.selected[itemNo]
            this.originalSelected[itemNo] = this.selected[itemNo]
          }
        })
        .catch(() => {})
    },
    async handleDeleteRowData() {
      this.$bvModal.hide(this.id)
      this.$emit('delete-row', this.indexInternal)
    },
    onCreate() {
      // When the edit modal shows and socket be notifying,
      // then will not be submitted if the update_time field value doesn't match.
      if (this.beNotifiedSocket && this.isEditModalMode && this.newItemData[UPDATE_TIME_KEY] !== this.preUpdateTimeFieldValue) {
        FlashMessage.getInstance().showErrorMessage('編集内容に変更があったため、保存できませんでした。詳細画面を閉じて更新してください。')
        return
      }
      const now = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      if (this.indexInternal === -1) {
        this.createData['insertTime'] = now
        for (let key in this.selected) {
          this.createData[key] = this.selected[key]
        }
      } else {
        for (let key in this.selected) {
          this.createData[key] = this.selected[key]
        }
        this.createData['updateTime'] = now
      }
      this.tableLabels.forEach(label => {
        this.$set(this.message, `${label.isItemNo}`, {})
      })
      if (this.validateCheck() && !this.isLoading) {
        this.$emit('action', this.createData)
        this.isSubmit = true
        this.beNotifiedSocket = false
      }
    },
    validateCheck() {
      var isValidateReslut = true
      for (let key in this.createData) {
        let value = this.createData[key]
        const validRule = this.option[key] || { rules: [] }
        validRule.rules.forEach(rule => {
          switch (true) {
            case rule === 'required_notZero':
              if (!value && value !== 0) {
                this.message[key][rule] = '必須項目です。'
              }
              break
            case rule === 'required':
              if (!value && value !== 0 && this.isRequiredKeyName(this.createData)) this.message[key][rule] = '必須項目です。'
              break
            case /min/.test(rule):
            case /max/.test(rule):
              const result = rule.split(':')
              if (!value && value !== 0) return
              let prefixStr = '文字'
              let dataValue = value.length
              const mstManagData = this.tableLabels.filter(
                x => x.isItemNo === key
              )
              if (mstManagData[0].dataType === FieldDataType.NUMBER) {
                prefixStr = ''
                dataValue = parseInt(value)
              }
              if (result[0] === 'min' && dataValue < parseInt(result[1])) {
                this.message[key][
                  result[0]
                ] = `${result[1]}${prefixStr}以上で入力してください`
              }
              if (result[0] === 'max' && dataValue > parseInt(result[1])) {
                this.message[key][
                  result[0]
                ] = `${result[1]}${prefixStr}以内で入力してください`
              }
              break
          }
        })
        if (this.message[key] && Object.keys(this.message[key]).length) isValidateReslut = false
      }
      return isValidateReslut
    },
    handleScrollToItem() {
      const element = document.querySelector(`[data-itemno='${this.itemNo}']`)
      VueScrollTo.scrollTo(element, 0, {offset: -15, container: '#scrollspy-filed'})
    },
    /**
     * チェックすると、編集モーダルにエラー メッセージが表示されます。
     * @param {boolean} itemEdited - アイテムが更新されました
     */
    async checkToShowErrorMsgOnEditModal(itemEdited) {
      this.beNotifiedSocket = true
      // Reset isEditModalMode when the socket message of the update item successfully
      if (itemEdited) {
        this.isEditModalMode = false
      }
      // Get the latest data of the record being edited
      await this.getCurrentItemData()
      if (this.isEditModalMode) {
        // Show an error msg when comparing the last update_time value with the update_time before it was edited
        if (!this.newItemData[UPDATE_TIME_KEY] || (this.newItemData[UPDATE_TIME_KEY] !== this.preUpdateTimeFieldValue && this.newItemData[this.primaryKey] === this.serialId)) {
          FlashMessage.getInstance().showErrorMessage('編集内容に変更があったため、保存できませんでした。詳細画面を閉じて更新してください。')
        }
      }
    },
    async getCurrentItemData() {
      this.newItemData = {}
      if (this.isEditModalMode && this.beNotifiedSocket) {
        const res = await this.$axios.get(`/${this.tableApi}?${this.primaryKey}=${this.serialId}`)
        if (res && res.data && res.data[this.tableNo] && res.data[this.tableNo][0]) {
          this.newItemData = res.data[this.tableNo][0]
        }
      }
    },
    async showModal(index, itemNo, formData = null) {
      this.beNotifiedSocket = false
      this.indexInternal = index
      this.message = {}
      this.createData = {}
      if (index === -1 && formData) { // Add New
        this.preUpdateTimeFieldValue = null
        this.isEditModalMode = false
        this.serialId = 0
        await this.getItemOrderSmallestInMstTable()
        this.itemNo = this.getItemOrderSmallestInMstTable()
        this.titleHeader = '追加'
        switch (Object.keys(formData).length === 0) { // Check condition object is empty
          case true: // Initialize form default value
            this.resetFormModal()
            break
          default: // Set the current value of form
            this.createData = formData.formData
            this.selected = formData.selected
            break
        }
      } else { // Edit
        this.itemNo = itemNo
        this.titleHeader = '詳細'
        this.createData = { ...this.tableData[index] }
        this.preUpdateTimeFieldValue = this.createData[UPDATE_TIME_KEY]
        this.serialId = this.createData[this.primaryKey]
        this.isEditModalMode = true
        delete this.createData.overlap
        for (let key in this.tableLabels) {
          let isItemNo = this.tableLabels[key].isItemNo
          let dataType = this.tableLabels[key].dataType
          if (dataType === FieldDataType.LIST) {
            let selectedIndex = Object.keys(this.createData).indexOf(isItemNo)
            this.$set(
              this.selected,
              Object.keys(this.createData)[selectedIndex],
              Object.values(this.createData)[selectedIndex]
            )
            if (this.tableNo === 'trTask' && isItemNo === 'status') { // task status field
              // タスクの場合、タスクステータスオプション表示/非表示設定
              this.taskStatusOptionsDisplaySetting(index, this.tableLabels[key].mstGenCode)
            }
          }
        }
        this.$_initValidateData()
      }
      this.originalSelected = {...this.selected}
      this.$bvModal.show(this.id)
    },
    async hideModal() {
      this.beNotifiedSocket = false
      this.isEditModalMode = false
      this.newItemData = {}
      // If show edit modal, it won't emit data out
      if (this.indexInternal !== -1) return
      // Else
      await (this.isSuccess && this.isSubmit)
        // If show add modal, click submit and submit success then hide modal -> emit object empty
        ? this.$emit('hide-modal', {})
        // If show add modal, no submit or submit error then hide modal -> emit current object data on form
        : this.$emit('hide-modal', {formData: {...this.createData}, selected: {...this.selected}})
      this.isSubmit = false
    },
    // Reset data form
    resetFormModal() {
      this.createData = {}
      this.tableLabels.forEach(mstItem => {
        this.$set(
          this.createData,
          `${mstItem.isItemNo}`,
          this.createData[mstItem.isItemNo] || ''
        )
        if (mstItem.mstGenCode.length && mstItem.dataType === 2) {
          this.$set(
            this.selected,
            `${mstItem.isItemNo}`,
            mstItem.mstGenCode[0].code
          )
        }
      })
      this.originalSelected = {...this.selected}
    },
    taskStatusOptionsDisplaySetting(index, options) {
      const taskType = this.tableData[index].taskType
      const status = this.tableData[index].status
      const noWorkTask = this.noWorkTaskType && this.noWorkTaskType.includes(taskType)
      const checkStatusIsDisabled = status === 0 || status === 1 || status === 5 || status === 2
      if (checkStatusIsDisabled || (status === 4 && noWorkTask)) {
        this.isDisabled = true
        return
      }
      this.isDisabled = false
      options.forEach((option, idx) => {
        const isCheckOptionsForStatus = (option.code === 0 || option.code === 1 || option.code === 5)
        // タスクステータスオプション表示/非表示設定(noDisplayFlag=true : 非表示、false : 表示)
        options[idx].noDisplayFlag = false
        // 作業指示なしの場合、ステータス(開始済)非表示設定
        if (noWorkTask && option.code === 2) {
          options[idx].noDisplayFlag = true
        }
        if (status === 3 && isCheckOptionsForStatus) {
          options[idx].noDisplayFlag = true
        }
        if (status === 4 && (isCheckOptionsForStatus || option.code === 3)) {
          options[idx].noDisplayFlag = true
        }
      })
    },
    isTextDisabled(isItemNo) {
      let isTextDisabled = false
      if (this.tableNo === 'trTask') {
        isTextDisabled = this.isDisabledTrTaskFields(isItemNo)
      }
      return isTextDisabled
    },
    isNumberDisabled(isItemNo) {
      let isNumberDisabled = false
      if (this.tableNo === 'trTask') {
        isNumberDisabled = this.isDisabledTrTaskFields(isItemNo)
      }
      return isNumberDisabled
    },
    isDisabledTrTaskFields(isItemNo) {
      let isDisabledField = false
      const status = this.originalSelected['status']
      switch (isItemNo) {
        case 'chuteNo':
          // Disable chuteNo in case status is 0, 3, 4, 5
          isDisabledField = [0, 3, 4, 5].includes(status)
          break
        case 'tileAngle':
          // Disable tileAngle in case status is 3, 4, 5
          isDisabledField = [3, 4, 5].includes(status)
          break
        case 'taskOrder':
          // Disable taskOrder in case status is 0, 3, 4, 5
          isDisabledField = [0, 3, 4, 5].includes(status)
          break
        default:
          break
      }
      return isDisabledField
    },
    getRulesMinMax(rules, isMax = true) {
      return RulesValidate.getMinMaxValue(rules, isMax)
    },
    // get item no has item order smallest from mst table by editable options
    getItemOrderSmallestInMstTable() {
      if (!this.option) return ''
      let customObjectMstTable = {}
      const itemNos = Object.keys(this.option)
      if (!itemNos) return ''
      const mstTableFiltered = this.tableLabels
        .filter(
          (tLabel) => tLabel['isItemNo'] === itemNos.find(item => item === tLabel.isItemNo)
        )
      if (!mstTableFiltered) return ''
      mstTableFiltered.forEach(el => {
        customObjectMstTable[el.itemOrder] = el.isItemNo
      })
      if (Object.keys(customObjectMstTable).length === 0) return ''
      return customObjectMstTable[Math.min(...Object.keys(customObjectMstTable))]
    },
    /**
     * 「settingkey」をチェックする必要があります 検証が必要です。
     * @param {array} createData 配列データです
     * @returns true は必須のキー名です、false キー名は必須ではありません
     */
    isRequiredKeyName(createData) {
      const settingKeyValue = createData['settingKey']
      if (settingKeyValue) {
        return !NOT_REQUIRED_SETTING_KEYS.includes(settingKeyValue)
      }
      return true
    },
    /**
     * チェックを入れると、Gen コード名または Gen コード番号が表示されます。
     * @param {number} genCodes 生成コードを確認したい
     * @param {number} selectedGenCodeValue 世代コードが選択されました
     * @return 生成コードが存在する場合は生成コード名を表示し、存在しない場合は選択した生成コードを表示します。
     */
    getGenCodeName(genCodes, selectedGenCodeValue) {
      if (!genCodes.length) {
        return selectedGenCodeValue
      }
      const genCode = genCodes.filter(genCode => !genCode.noDisplayFlag).find(x => x.code === selectedGenCodeValue)
      if (!genCode) {
        return selectedGenCodeValue
      }
      return genCode.name
    },
    /**
     * テキストエリアを表示できるか確認してください。
     * @param {boolean} isItemNo アイテム番号
     * @param {number} index インデックス
     * @returns テキストエリアを表示する場合は true、それ以外の場合は false を返します
     */
    checkShowTextArea(isItemNo, index) {
      if (this.tableNo !== 'mstDevSetting') {
        return false
      }
      return this.tableData[index].dataType === DevSettingDataType.TEXT_AREA && FIELD_LIST.includes(isItemNo)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-modal-header {
  font-style: normal;
  font-weight: normal;
  @include responsive-fs(20);
  line-height: 160%;
  width: auto;
  .buttonSave {
    align-self: center;
    background: $sucess;
    border: 2px solid $base_border_blue;
    border-radius: 4px;
    text-decoration: none;
    overflow: hidden;
    white-space: nowrap;
    min-width: 65px;
    min-height: 35px;
    background-color: $base_blue_light;
    margin: 0px 35px;
    &:hover {
      background-color: #475C97;
    }
  }
  .delete_btn {
    color: $base_red;
    .delete_icon_detail {
      @include responsive-fs(15);
    }
    &:hover {
      text-decoration: none;
      color: $base_red;
    }
    &:focus {
      background: rgba(180, 27, 62, 0.08);
      border-radius: 40px;
    }
  }
  .buttonReset {
    text-decoration: none;
  }
}
.titleHeader {
  font-style: normal;
  font-weight: bold;
  @include responsive-fs(20);
}
.lblItemName, .lblInputField {
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  word-break: break-word;
  @include responsive-fs(14);
}
#scrollspy-filed {
  position: relative;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}
.modal-body {
  padding-top: 0px !important;
}
.txtErrorMessage {
  padding: 0 0.35rem !important;
}
/* #scrollspy-filed::-webkit-scrollbar {
  display: none;
} */
/deep/ .modal-dialog {
  min-width: 40vw;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/AddEditModalComponent.vue